import { ReactNode } from 'react'

import Button from 'common/components/button'

export interface Props {
  cardText: string | ReactNode
  cardTitle: string
  buttonText: string
  isDisabled: boolean
  onSubmit: () => void
  onReject: () => void
  rejectButtonText: string
  isLoading: boolean
}

export default function ConfirmationCard({
  cardText,
  onSubmit,
  onReject,
  isLoading,
  cardTitle,
  buttonText,
  isDisabled,
  rejectButtonText,
}: Props) {
  return (
    <div className="mt-4 mb-4 bg-white p-4 border border-gray-200">
      <div className="flex text-2xl mb-4">
        <div className="font-bold ml-4 mt-2 text-red-600">{cardTitle}</div>
      </div>
      <div className="mb-4 text-coolGray-800">{cardText}</div>
      <div className="content-end flex flex-wrap">
        <Button
          variant="link"
          disabled={isDisabled}
          data-testid="confirmRejectBtn"
          onClick={() => onReject()}
          className="ml-auto"
        >
          {rejectButtonText}
        </Button>
        <Button
          variant="danger"
          loading={isLoading}
          disabled={isDisabled}
          data-testid="confirmBtn"
          onClick={() => onSubmit()}
          className="ml-4"
        >
          {buttonText}
        </Button>
      </div>
    </div>
  )
}
